import { pushToWeborama } from '@beef/shop-common';

import { cookieShopVisitedService } from 'services/cookieShopVisitedService';
import { cookieBasketService } from 'services/cookieBasketService';

export const pushWeboramaAnalytics = () => {
  const visited = cookieShopVisitedService.getVisited();
  const source = document.referrer.replace(/https?:\/\//i, '');
  const basketId = cookieBasketService.getBasketIdCookie();

  pushToWeborama({
    conversion_page: 199,
    invoice_id: basketId,
    is_client: visited ? 0 : 1, // set to 1 if new client
    optional_parameters: {
      URL: source,
    },
  });
};
